
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 324 331"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.347 17.057c-2.286 1.132-5.433 3.903-7 6.164L15.5 27.329v183.485l3.058 3.843c1.682 2.114 5.04 4.856 7.462 6.093l4.404 2.25H236.457l-30.681 30.75c-20.389 20.435-31.2 31.997-32.229 34.468-4.149 9.97 1.133 23.078 10.768 26.718 4.076 1.541 12.167 1.305 16.467-.478 5.077-2.106 103.451-100.277 106.243-106.024 2.578-5.306 2.598-13.316.046-18.224-1.061-2.04-25.024-26.738-53.25-54.883-46.575-46.441-51.737-51.283-55.821-52.36-14.805-3.905-28.546 9.69-24.91 24.645 1.117 4.596 3.285 6.995 36.267 40.138L244.436 183H55v-76.032c0-82.203.138-79.975-5.298-85.802-5.809-6.228-16.448-8.023-24.355-4.109","fill-rule":"evenodd"}})])
          )
        }
      }
    